<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container mt-3 mb-5" *ngIf="!loading">
  <app-question-history-dashboard *ngFor="let history of surveyQuestionHistories; let i = index" [questionHistory]="history"/>

  <mat-paginator
    class="mt-5"
    [length]="totalSurveyQuestionHistories"
    [pageSize]="pageSize"
    [pageIndex]="currentPageIndex"
    [pageSizeOptions]="[1, 5, 10]"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>
